export default "__VITE_ASSET__Cy09egre__"